var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62818 10.9296C5.21344 11.3568 4.54349 11.3568 4.12875 10.9296L0.311052 6.99687C-0.103684 6.56964 -0.103684 5.8795 0.311052 5.45227C0.725788 5.02504 1.39575 5.02504 1.81048 5.45227L4.87315 8.6072L12.1895 1.07042C12.6043 0.643192 13.2742 0.643192 13.6889 1.07042C14.1037 1.49765 14.1037 2.18779 13.6889 2.61502L5.62818 10.9296Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-mark.80a99be86a89ab1e9a2051eda4225d61.svg";